@let info = widgetData();

<div
  class="count-widget-container d-flex align-center justify-between h-full px-4 py-2 text-center"
>
  <div class="d-flex flex-column gap-2 text-sm">
    @if (info.length > 0) {
      @for (item of info; track $index) {
        <div
          style="border-bottom-style: solid"
          class="flex justify-between items-center border-b border-outline-variant! py-2 max-sm:flex-wrap max-sm:gap-2"
        >
          <p class="text-truncate my-0 max-sm:w-full max-sm:overflow-visible max-sm:text-clip max-sm:whitespace-normal max-sm:break-words">
            {{ item[keyParams()!] }}
          </p>

          <button
            [disabled]="!widget().config.path?.viewAll"
            matMiniFab
            [attr.aria-label]="
              widget().config.path?.viewAll
                ? widget().config.path?.viewAll +
                  ' ' +
                  item[keyParams()!] +
                  ' ' +
                  '(' +
                  item?.count +
                  ')'
                : 'Vai alla lista'
            "
            (click)="onCountClick(item)"
            [matTooltip]="widget().config.path?.viewAll ? 'Vai alla lista' : ''"
          >
            {{ item?.count }}
          </button>
        </div>
      }
    } @else {
      <div class="flex justify-center items-center w-full h-full">
        Nessun dato da visualizzare
      </div>
    }
  </div>
</div>
